import { useEffect } from "react";
import { useContent } from "../content/ContentContext";
import { setPageMeta } from "../lib/seo";
import { SectionLabel } from "../components/Ui";
import { Reveal } from "../components/Reveal";

export default function Privacy() {
  const { content } = useContent();
  const site = content.site;
  useEffect(() => {
    setPageMeta(
      "Privacy Notice — Savvy Stephanie Analytics & Consulting",
      "How enquiries and contact data are handled on this website: what is collected, how it is used, and how to have it removed."
    );
  }, []);
  const sections = [
    {
      h: "Who I am",
      p: `This website is operated by ${site.owner} (${site.businessName}), ${site.location}. You can contact me at ${site.email} for anything related to privacy or your data.`,
    },
    {
      h: "What I collect",
      p: "When you use the enquiry form I collect the details you provide: your name, email address, optional company name, the service you select, your description of what you need, and any optional budget range or preferred start date. No other personal data is collected.",
    },
    {
      h: "How your enquiry is used",
      p: "Enquiry details are stored in the website's application database and are visible only to me through a password-protected owner area. I use them solely to read and respond to your enquiry. Enquiries are never published, and there are no third-party recipients.",
    },
    {
      h: "Cookies and trackers",
      p: "This website sets no marketing or analytics trackers. The only cookie used is a strictly technical authentication cookie for my private owner area, which is set only when I sign in as the owner — visitors never receive it.",
    },
    {
      h: "How long enquiries are kept",
      p: "[To confirm] A retention period will be set here — for example, enquiries removed after 12 months of the last contact.",
    },
    {
      h: "Your rights",
      p: `You can ask me at any time to confirm what I hold about you, correct it, or delete it — simply email ${site.email}.`,
    },
    {
      h: "Hosting",
      p: "The site is hosted on the platform's preview subdomain while in review. [To confirm] The final hosting arrangement, including any subdomain or domain used at launch, will be reflected here before publication.",
    },
    {
      h: "Changes to this notice",
      p: "[Owner note] This notice was drafted alongside the first version of the site and should be reviewed once hosting and business registration details are confirmed.",
    },
  ];
  return (
    <main className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
      <Reveal>
        <SectionLabel>Privacy notice</SectionLabel>
        <h1 className="mt-5 font-serif text-4xl font-semibold tracking-tight text-ink sm:text-5xl">
          How your data is handled.
        </h1>
        <p className="mt-6 text-sm italic text-muted">
          Plain-language notice reflecting the current setup. Items marked [To confirm]
          need the site owner&rsquo;s final details before publication.
        </p>
      </Reveal>
      <div className="mt-12 space-y-10">
        {sections.map((s, i) => (
          <Reveal key={s.h} delay={i * 0.03}>
            <section>
              <h2 className="font-serif text-xl font-medium text-ink">{s.h}</h2>
              <p className="mt-3 leading-relaxed text-muted">{s.p}</p>
            </section>
          </Reveal>
        ))}
      </div>
    </main>
  );
}
